import React from "react";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";
import dayjs from "dayjs";


const ParkDetails = ({ data }) => {
  return (
    <ParkDetailContainer>
      <div>
        <DetailDiv>
          <ParkTitle>{data.outletName}</ParkTitle>
          <ParkDetail>
            <span>
              {dayjs(data.bookingDate).format("dddd - MMMM DD, YYYY")}
            </span>
            <span>, {data.location}</span>
          </ParkDetail>
        </DetailDiv>
        <ParkImg src={data.logo} />
      </div>
    </ParkDetailContainer>
  );
};

const ParkDetailContainer = styled.div`
  display: flex;
  padding: 1rem;
  box-sizing: border-box;
  justify-content: center;
  margin-top: 2rem;

  > div {
    display: flex;

    width: 1024px;
    justify-content: space-between;
  }
  @media only screen and (max-width: 1024px) {
    padding: 1rem 2rem;
  }
  @media only screen and (max-width: 640px) {
    gap: 0rem;
  }
`;

const DetailDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const ParkTitle = styled.span`
  color: ${Colors.arsenic};
  font-size: 1rem;
  font-weight: 600;
  @media only screen and (max-width: 640px) {
    font-size: 0.938rem;
  }
`;
const ParkDetail = styled.span`
  color: ${Colors.dustyGray};
  font-size: 1rem;
  font-weight: 400;
  @media only screen and (max-width: 640px) {
    font-size: 0.875rem;
  }
`;
const ParkImg = styled.img`
  width: 6rem;
  height: 6rem;
  @media only screen and (max-width: 640px) {
    width: 4rem;
    height: 4rem;
  }
`;

export default ParkDetails;
